import React from 'react';
import { useSelector } from 'react-redux';
import { accountModerationState, formatModerationTime, normalizeAccountModeration } from '@/utils/accountModeration';
import './index.scss';

const AccountModerationNotice = () => {
  const { isAuthenticated, userInfo, accountNotice } = useSelector(state => state.user);
  const data = normalizeAccountModeration(accountNotice || userInfo?.account_moderation);
  if (!isAuthenticated || !data || (!data.violation_count && !data.notice)) return null;
  const status = accountModerationState(data);
  const until = formatModerationTime(data.banned_until);
  return <section className="accountModerationNotice" data-level={status?.activeBan ? 'ban' : 'warning'} role="status" aria-label="账号处罚提醒">
    <span className="accountModerationNotice-icon" aria-hidden="true">!</span>
    <div><strong>{status?.label || '账号提醒'}<span>累计 {data.violation_count} 次举报审核成立</span></strong>
      <p>{data.notice || '请遵守社区规则，后续违规将按累计次数处理。'}</p>
      {status?.activeBan && until && <p>封禁截止：{until}（北京时间）</p>}
    </div>
  </section>;
};

export default AccountModerationNotice;
